import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { getHelps } from '../../redux/reducers/helps';
// components
import { Switch, Redirect, NavLink, Route } from 'react-router-dom';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import HelpsList from './components/HelpsList';
import ContactUs from './components/ContactUs';
import Preloader from '../../components/Preloader/Preloader';
// utils
import { toastResponseErrors } from '../../utils/response';
// styles
import styles from './Help.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class Help extends Component {
  componentDidMount() {
    const { getHelps, resources } = this.props;
    if (!resources) {
      getHelps().catch(toastResponseErrors);
    }
  }

  render() {
    const { resources, isLoading } = this.props;

    return (
      <PageWrapper className="mr-30 ml-30">
        <div className={cn(styles.wrapper, 'row')}>
          <div className={cn(styles.menu, 'col-sm-3 col-xs-12')}>
            <NavLink to="/help" exact>
              General information
            </NavLink>
            <NavLink to="/help/subscription">Subscription</NavLink>
            <NavLink to="/help/personal-info">Personal information</NavLink>
            <NavLink to="/help/contact-us">Contact Us</NavLink>
          </div>

          <div className="col-sm-9 col-xs-12">
            <Preloader isActive={isLoading} />
            {resources &&
              resources.length && (
                <Switch>
                  <Route
                    exact
                    path="/help"
                    component={() => <HelpsList type="general_information" />}
                  />
                  <Route
                    path="/help/subscription"
                    component={() => <HelpsList type="subscription" />}
                  />
                  <Route
                    path="/help/personal-info"
                    component={() => <HelpsList type="personal_information" />}
                  />
                  <Route path="/help/contact-us" component={ContactUs} />
                  <Redirect to="/help" />
                </Switch>
              )}
          </div>
        </div>
      </PageWrapper>
    );
  }
}

Help.propTypes = {
  resources: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      title: T.string.isRequired,
      text: T.string.isRequired
    }).isRequired
  ),
  getHelps: T.func.isRequired
};

export default connect(
  state => ({
    resources: state.helps.resources,
    isLoading: state.helps.isLoading
  }),
  { getHelps }
)(Help);



// WEBPACK FOOTER //
// ./src/containers/Help/Help.jsx